import { css } from '@emotion/react';
import { Link } from 'react-router-dom';
import { CONFIG } from '~/_shared/constants/config';
import type { Theme } from '~/_shared/themes/theme.model';
import { StandardFeatureToggle } from '~/featureToggles/standardFeatureToggle.component';

const pageStyle = css({
  maxWidth: '800px',
  minWidth: '800px',
  margin: '0 auto',
  padding: 10,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  gap: 20,
});

const headingStyle = css({
  minWidth: 120,
  flexShrink: 0,
  textTransform: 'uppercase',
});

const checkboxPileStyle = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 10,
});

const linkStyle = (theme: Theme) => css({
  color: theme.textColors.link,
  textDecoration: 'none',
  '&:hover': {
    color: theme.textColors.linkOnHover,
  },
});

export const FeatureTogglesPageComponent = () => {
  return (
    <div css={pageStyle}>
      <title>Maptive | Feature toggles</title>
      <h1 css={headingStyle}>
        Feature Toggles
      </h1>

      <p>
        ⚠️️ Warning<br />
        All these features are unreleased and may be unstable. Use them at your own risk.
      </p>

      <div>
        <h3 css={headingStyle}>
          Force the following features enabled
        </h3>
        <div css={checkboxPileStyle}>
          <StandardFeatureToggle
            featureName="ENABLE_COMPLETE_MIGRATION"
            label="Enable complete migration"
          />
          <StandardFeatureToggle
            featureName="ENABLE_TERRITORY_QUICK_EDIT"
            label="Enable quick editing of territories"
          />
          <StandardFeatureToggle
            featureName="ENABLE_SSO_LOGIN"
            label="Enable SSO login"
          />
          <StandardFeatureToggle
            featureName="ENABLE_DATA_LAYERS"
            label="Enable Data Layers Tool"
          />
          <StandardFeatureToggle
            featureName="ENABLE_PLACES"
            label="Enable Places Tool"
          />
        </div>
        {CONFIG.MODE === 'development' && (
          <>
            <h4 css={headingStyle}>
              Development only features
            </h4>
            <div css={checkboxPileStyle}>
              <StandardFeatureToggle
                featureName="ENABLE_MAPTIVE_OPTIMISED_TERRITORIES"
                label="Enable maptive optimised territories"
              />
              <StandardFeatureToggle
                featureName="ENABLE_OPTIMIZED_TERRITORY_AUTO_NAME_BUILDER"
                label="Enable optimized territory auto name builder"
              />
              <StandardFeatureToggle
                featureName="ENABLE_PDF_EXPORT"
                label="Enable PDF export"
              />
            </div>
          </>
        )}
      </div>
      <p>
        ⚠️️ Warning ️<br />
        After making the required modifications you’ll need to <b><em>⚠️️refresh all instances⚠️️</em></b> of the
        Maptive app in all browser tabs you have currently open in order for the new settings to take effect.
      </p>
      <Link to="/" css={linkStyle}>Back to the main app</Link>
    </div>
  );
};
